// @ts-expect-error has no types is polyfill
import ho from "object.hasown"

export const hasOwn = ho
